import React from 'react';
import s from '../Product.module.css';
import Product from '../Product';
import Nav from '../../Nav/Nav';

const Burgers = (props) => {
    return (
        <div className={s.container}>
            <Nav link='/makmenu' name='Бургери'/>
            <main className={s.main}>
                <Product name='Чізбургер' price='130 грн.' weight='310г.' info1='булочка, котлета куряча, листя салату, помідор, огірок маринований, соус сирний, сир тостовий'/>
                <Product name='Бургер' price='130 грн.' weight='330г.' info1='булочка, свинна котлета, листя салату, помідор, огірок маринований, соус сирний, соус бургерний, цибуля'/>
                <Product name='Бургер з сиром Дана-блю' price='150 грн.' weight='330г.' info1='булочка, свинна котлета з паприкою, листя салату, помідор, огірок маринований, соус барбекю, соус лимонно-гірчичний на майонезі, червона цибуля карамелізована'/>
                <Product name='Бургер з лососем' price='140 грн.' weight='240г.' info1='булочка, лосось, листя салату, помідор, огірок маринований, соус лимонно-гірчічний на майонезі, барбекю'/>
            </main>
        </div>
    )
}

export default Burgers;